import { debounceTime, fromEvent } from 'rxjs';

class ScrollLock {
  private readonly CLASS_LIST = ['overflow-hidden', '[&_body]:pe-[var(--scroll-bar-width)]'];

  constructor() {
    ScrollLock.setScrollBarWidth();
    fromEvent(document, 'resize').pipe(debounceTime(250)).subscribe(ScrollLock.setScrollBarWidth);
  }

  static setScrollBarWidth() {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scroll-bar-width', `${scrollBarWidth}px`);
  }

  lock() {
    document.documentElement.classList.add(...this.CLASS_LIST);
  }

  unlock() {
    document.documentElement.classList.remove(...this.CLASS_LIST);
  }
}

export default new ScrollLock();
